import { useCallback } from 'react';

import { useTranslation } from '@lyearn/i18n';
import { AlertTriangleFill } from '@lyearn/icons';
import { useSnackbar } from '@lyearn/ui';
import useDefaultErrorSnackbar from '@/hooks/useDefaultErrorSnackbar';
import { GenerativeTaskErrorCodeEnum, GenerativeTaskErrorType } from '@/types/schema';

export default function useAIError() {
  const { t } = useTranslation('AI');
  const { showDefaultErrorSnackbar } = useDefaultErrorSnackbar();
  const { showSnackbar } = useSnackbar();

  const handleAIError = useCallback(
    (generativeTaskError?: GenerativeTaskErrorType | null) => {
      if (generativeTaskError) {
        if (generativeTaskError.errorCode === GenerativeTaskErrorCodeEnum.TokenLimitExceeded) {
          showSnackbar({
            startIcon: (
              <AlertTriangleFill className="h-20 w-20" fillColorToken="icon-warning-light" />
            ),
            message: t('AI:LongPromptError'),
            // action: (
            //   <Link appearance="inverse" className="flex-shrink-0" onClick={console.log}>
            //     {t('Common:Actions.TryAgain')}
            //   </Link>
            // ),
          });
          return true;
        }

        showDefaultErrorSnackbar();
        return true;
      }

      return false;
    },
    [showDefaultErrorSnackbar, showSnackbar, t],
  );

  return { handleAIError };
}
